module.exports = {
	EVENTS: {
		OTHER_WINDOW_READY: 'swOtherWindowBusOtherWindowReady',
		OTHER_WINDOW_READY_CONFIRMED: 'swOtherWindowBusOtherWindowReadyConfirmed'
	},
	PINGBACK_POSTFIX: '_swPingback'
};